import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../reducers';
import { selectAuthLoggedIn, selectAuthUserType } from '../features/auth/auth.selectors';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
// import { getMfaAuth } from 'ngpd-merceros-mfa-fe-components';
import { getCookie } from './cookies.service';
import { combineLatest } from 'rxjs';
import { AuthService } from '../features/auth/auth.service';

@Injectable()
export class AuthenticatedGuard implements CanActivate, CanActivateChild {
  public constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly _authService: AuthService
  ) {
  }

  public canActivate(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize();
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize(route.routeConfig.path);
  }

  private authorize(path?): Observable<boolean> {
    return combineLatest([
      this._authService.mssoLoggedIn$,
      this.store.pipe(select(selectAuthUserType))
    ])
      .pipe(
        map(([logged, userType]) => {
          if (logged) {
            if (userType === 'internal' && path === 'my-contacts') {
              this.router.navigate(['/contacts/contact-us']);
              return false;
            } else {
              return true;
            }
          } else {
            const cookieToken = getCookie('auth_token');
            if (cookieToken) {
              this.router.navigate(['/provision/login'], { queryParams: { reason: 'USER_SESSION_EXPIRED' } });
            } else {
              this.router.navigate(['/provision/login']);
            }
            return false;
          }
        })
      );
  }
}
